type MemberInput = {
  name?: string;
  age?: string;
  its?: string;
  gender?: string;
  jamaat?: string;
};

export function validateFamilyMembers(
  familyMembers: MemberInput[] | undefined,
  required: boolean
): string | Record<string, string>[] | undefined {
  if (!familyMembers || !familyMembers.length) {
    return required ? "Atleast 1 Family Member required" : undefined;
  }

  return familyMembers.map((member) => {
    const memberErrors: Record<string, string> = {};
    if (!member?.name) {
      memberErrors.name = "The name is required";
    }
    if (!member?.age) {
      memberErrors.age = "The age is required";
    }
    if (!member?.its) {
      memberErrors.its = "The its is required";
    }
    if (!member?.gender) {
      memberErrors.gender = "The gender is required";
    }
    return memberErrors;
  });
}

export function validateMehmaans(
  mehmaans: MemberInput[] | undefined
): Record<string, string>[] | undefined {
  if (!mehmaans?.length) {
    return undefined;
  }

  return mehmaans.map((member) => {
    const memberErrors: Record<string, string> = {};
    if (!member?.name) {
      memberErrors.name = "The name is required";
    }
    if (!member?.age) {
      memberErrors.age = "The age is required";
    }
    if (!member?.its) {
      memberErrors.its = "The its is required";
    }
    if (!member?.gender) {
      memberErrors.gender = "The gender is required";
    }
    if (!member?.jamaat) {
      memberErrors.jamaat = "The jamaat is required";
    }
    return memberErrors;
  });
}
